// The live store, for modules the store itself imports (utils/api are pulled in by
// store/actions.js). They must not `import { store } from '@/store/store'`: that closes
// the cycle store -> actions -> utils -> store, and whoever loads actions.js first (the
// Jest security specs do) constructs the store while actions.js is half-evaluated —
// Vuex then rejects `actions.azureCallback` as undefined (2026-09-20). store.js registers
// itself here right after construction; consumers read it at call time, never at import.
let current = null;

export const registerStore = (store) => {
    current = store;
};

// Fallback for code paths where nothing registered yet (a unit test that mocks
// '@/store/store' and imports api.js or utils.js directly): resolve the module at call
// time. This is the same dependency, but taken when the app is already running, not
// while modules are still evaluating, so it cannot recreate the load-order failure.
export const getStore = () => {
    if (current === null) {
        current = require('@/store/store').store; // eslint-disable-line global-require
    }
    return current;
};
